import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { Request } from './request';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RequestService {
  constructor(private http: HttpClient) {}

  findAll(params: HttpParams): Observable<any> {
    const url = `${environment.url.api}/a/request`;
    return this.http
      .get<any>(url, { params })
      .pipe(timeout(environment.config.apiWaitingTime));
  }

  findByCompanyId(params: HttpParams, companyId: string): Observable<any> {
    const url = `${environment.url.api}/a/request/companyId/${companyId}`;
    return this.http
      .get<any>(url, { params })
      .pipe(timeout(environment.config.apiWaitingTime));
  }

  findOne(id: string): Observable<any> {
    const url = `${environment.url.api}/a/request/${id}`;
    return this.http.get<Request>(url).pipe(timeout(environment.config.apiWaitingTime));
  }

  create(request: Request): Observable<any> {
    const url = `${environment.url.api}/request`;
    return this.http.post<Request>(url, request).pipe();
  }

  save(request: Request): Observable<any> {
    const url = `${environment.url.api}/a/request/${request.id}`;
    return this.http.put<Request>(url, request).pipe(timeout(environment.config.apiWaitingTime));
  }

  delete(id: string): Observable<any> {
    const url = `${environment.url.api}/a/request/${id}`;
    return this.http.delete<Request>(url).pipe(timeout(environment.config.apiWaitingTime));
  }

  confirm(request: Request): Observable<any> {
    const url = `${environment.url.api}/a/request/${request.id}/confirm`;
    return this.http.put<Request>(url, request).pipe(timeout(environment.config.apiWaitingTime));
  }

  approve(request: Request): Observable<any> {
    const url = `${environment.url.api}/a/request/${request.id}/approve`;
    return this.http.put<Request>(url, request).pipe(timeout(environment.config.apiWaitingTime));
  }

  denied(request: Request): Observable<any> {
    const url = `${environment.url.api}/a/request/${request.id}/denied`;
    return this.http.put<Request>(url, request).pipe(timeout(environment.config.apiWaitingTime));
  }

  checkUseIP(userId: string, localIp: string, remoteIp: string): Observable<any> {
    const url = `${environment.url.api}/validations/request/check-ip`;
    const params: HttpParams = new HttpParams().set('userId', userId).set('localIp', localIp).set('remoteIp', remoteIp);
    return this.http
      .get<Request>(url, { params: params })
      .pipe(timeout(environment.config.apiWaitingTime));
  }

  existsEmail(email: string): Observable<any> {
    const url = `${environment.url.api}/validations/request/exists-email`;
    const params: HttpParams = new HttpParams().set('email', email);
    return this.http
      .get<Request>(url, { params: params })
      .pipe(timeout(environment.config.apiWaitingTime));
  }
}
